"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsSectionHeaderContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var SearchFilters_1 = require("icf-search-client-data/lib/SearchFilters");
var OnlineOfflineMode_1 = require("icf-search-client-shared/lib/constants/OnlineOfflineMode");
var XmentService_1 = require("icf-search-client-shared/lib/services/XmentService");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var SearchResultsGridHelpers_1 = require("./SearchResultsGridHelpers");
var SearchResultsSectionHeader_1 = require("./SearchResultsSectionHeader");
var SearchResultsSectionHeaderTitle_1 = require("./SearchResultsSectionHeaderTitle");
var SearchResultsSectionThumbnails_1 = require("./SearchResultsSectionThumbnails");
var SearchResultsSectionHeaderContainer = /** @class */ (function (_super) {
    __extends(SearchResultsSectionHeaderContainer, _super);
    function SearchResultsSectionHeaderContainer() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this._getFallbackMessage = function (resultsContext, queryOptions, translate) {
            var _a;
            var totalItemCount = resultsContext.totalItemCount, totalOnlineItemCount = resultsContext.totalOnlineItemCount, isFallback = resultsContext.isFallback;
            var isShowOnlineCountXmentEnabled = (_a = _this.props.xmentService) === null || _a === void 0 ? void 0 : _a.isXmentVariationOn(XmentService_1.SEARCH_SHOW_ONLINE_COUNT_XMENT_NAME);
            if ((0, SearchResultsGridHelpers_1.shouldShowPerformerGrid)(resultsContext.errors)) {
                return isFallback && (queryOptions.type === "browse" ? !queryOptions.isNotFound : true)
                    ? {
                        message: translate("search.fallback_suggestions"),
                        totalPerformersText: isShowOnlineCountXmentEnabled
                            ? "".concat(totalOnlineItemCount, " ").concat(translate("search.online_performers_found"))
                            : "".concat(totalItemCount, " ").concat(translate("search.models_found")),
                    }
                    : null;
            }
            else {
                /* istanbul ignore next -- This is confusing because there's no complaint about branch coverage above */
                return {
                    message: "",
                    totalPerformersText: "",
                };
            }
        };
        return _this;
    }
    SearchResultsSectionHeaderContainer.prototype._shouldDisplayDropDowns = function () {
        var _a = this.props, dataSource = _a.dataSource, isOverFiltered = _a.isOverFiltered, queryOptions = _a.queryOptions;
        // If the type is a category, we should not display drop-downs if the category is 'recents'.
        // If the type is 'favorites' we should not display drop-downs (pending xment)
        if (queryOptions.type === "category") {
            return queryOptions.category !== "recents";
        }
        else if (queryOptions.type === "favorites") {
            // if isFallback is false, then we know we have favorites
            // if isFallback is true and isOverFiltered is true, we still want to show the filters
            // if isFallback is true and isOverFiltered is false,
            //  then we don't have any favorites, so we won't show the filters
            return !dataSource.resultsContext.value.isFallback || isOverFiltered;
        }
        return true;
    };
    SearchResultsSectionHeaderContainer.prototype._getTotalPerformersText = function (filters, resultsContext, totalPerformers, translate) {
        var _a = this.props, isFirstGrid = _a.isFirstGrid, onlineOfflineMode = _a.onlineOfflineMode, queryOptions = _a.queryOptions, xmentService = _a.xmentService;
        var isFallback = resultsContext.isFallback, totalOnlineItemCount = resultsContext.totalOnlineItemCount;
        var isShowOnlineCountXmentEnabled = xmentService === null || xmentService === void 0 ? void 0 : xmentService.isXmentVariationOn(XmentService_1.SEARCH_SHOW_ONLINE_COUNT_XMENT_NAME);
        var isOnlineFilterOn = filters &&
            (0, SearchFilters_1.getAdvancedFilterArray)(filters).some(function (filter) {
                return filter.name === "online" && filter.value;
            });
        if (isShowOnlineCountXmentEnabled) {
            if (isFallback || (onlineOfflineMode === OnlineOfflineMode_1.ONLINE_OFFLINE_MODE_OFFLINE && isFirstGrid)) {
                return null;
            }
            if (queryOptions.type === "favorites") {
                return totalPerformers + " " + translate("search.models_found");
            }
            return ((isOnlineFilterOn ? totalPerformers : totalOnlineItemCount) + " " + translate("search.online_performers_found"));
        }
        return isFallback || !isOnlineFilterOn ? null : totalPerformers + " " + translate("search.models_found");
    };
    SearchResultsSectionHeaderContainer.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsx)(Ioc_1.ContextConsumer, { contexts: [Contexts_1.ITranslationServiceContext, Contexts_1.ILayoutContext, Contexts_1.IThemeContext], children: function (translationService, layout, theme) {
                var _a, _b;
                var _c = _this.props, emitTrackingEvent = _c.emitTrackingEvent, eventPublisher = _c.eventPublisher, isFirstGrid = _c.isFirstGrid, isOverFiltered = _c.isOverFiltered, onFilterChange = _c.onFilterChange, onOfflineButtonClicked = _c.onOfflineButtonClicked, onOnlineButtonClicked = _c.onOnlineButtonClicked, onlineOfflineMode = _c.onlineOfflineMode, onRemoveFilter = _c.onRemoveFilter, openMobileFilterModal = _c.openMobileFilterModal, onThumbnailSizeChange = _c.onThumbnailSizeChange, queryOptions = _c.queryOptions, setTotalPerformers = _c.setTotalPerformers, thumbnailSize = _c.thumbnailSize, toggleFiltersModal = _c.toggleFiltersModal, toggleSearch = _c.toggleSearch, dataSource = _c.dataSource, router = _c.router, user = _c.user, xmentService = _c.xmentService, hideBackToOnlineLink = _c.hideBackToOnlineLink, setCategoryGroupIndex = _c.setCategoryGroupIndex, setCurrentCategory = _c.setCurrentCategory, categoryGroups = _c.categoryGroups, categoryGroupIndex = _c.categoryGroupIndex, setGenderPreference = _c.setGenderPreference, emitGenderTabEvent = _c.emitGenderTabEvent, pushRoute = _c.pushRoute;
                var resultsContext = dataSource.resultsContext.value;
                var totalPerformers = dataSource.totalItemCount.value;
                var ageVerificationRules = user === null || user === void 0 ? void 0 : user.ageVerificationRules;
                var filters = queryOptions.filters;
                // @ts-expect-error (we handle the undefined case later)
                var _d = (function () {
                    var headerTitleData = (0, SearchResultsSectionHeaderTitle_1.getHeaderTitle)(__assign(__assign({}, _this.props), { onlineOfflineMode: onlineOfflineMode, translate: translationService.translate, resultsContext: resultsContext, ageVerificationRules: ageVerificationRules }));
                    return headerTitleData !== null && headerTitleData !== void 0 ? headerTitleData : {};
                })(), message = _d.message, blurMessage = _d.blurMessage;
                var overFilteredFallbackMessage = translationService.translate("search.fallback_suggestions");
                var noResultsMessage = queryOptions.type === "favorites" && !isOverFiltered
                    ? translationService.translate("search.no_favorites_subheader")
                    : translationService.translate("search.no_results_filter", { string: message });
                var resultsMessage = queryOptions.type === "keyword"
                    ? translationService.translate("search.success_results_filter", { string: message })
                    : queryOptions.type === "tag"
                        ? translationService.translate("search.success_tags_filter", { string: message })
                        : "";
                var isUserAuthenticated = user === null || user === void 0 ? void 0 : user.isAuthenticated;
                var fallback = _this._getFallbackMessage(resultsContext, queryOptions, translationService.translate);
                var genderFilter = (_a = queryOptions.filters) === null || _a === void 0 ? void 0 : _a.gender;
                return (
                // TODO: Holy shit.
                (0, jsx_runtime_1.jsx)(SearchResultsSectionHeader_1.SearchResultsSectionHeader, { emitTrackingEvent: emitTrackingEvent, eventPublisher: eventPublisher, filters: filters, isFirstGrid: isFirstGrid, isLarge: layout.breakpoint === "large", onlineOfflineMode: onlineOfflineMode, isOverFiltered: isOverFiltered, isUserAuthenticated: !!isUserAuthenticated, fallback: fallback !== null && fallback !== void 0 ? fallback : undefined, hasInitialResults: dataSource.hasInitialResults.value, message: message, onFilterChange: onFilterChange, onOfflineButtonClicked: onOfflineButtonClicked, onOnlineButtonClicked: onOnlineButtonClicked, onRemoveFilter: onRemoveFilter, openMobileFilterModal: openMobileFilterModal, onThumbnailSizeChange: onThumbnailSizeChange, overFilteredFallbackMessage: overFilteredFallbackMessage, noResultsMessage: noResultsMessage, resultsMessage: resultsMessage, path: router ? router.location.pathname : undefined, refreshGrid: function () {
                        dataSource.reset();
                    }, setTotalPerformers: setTotalPerformers, shouldDisplayDropDowns: _this._shouldDisplayDropDowns(), theme: theme, translate: translationService.translate, thumbnailSize: thumbnailSize || SearchResultsSectionThumbnails_1.ThumbnailSize.medium, toggleFiltersModal: toggleFiltersModal, toggleSearch: toggleSearch, totalPerformers: totalPerformers, totalPerformersText: (_b = _this._getTotalPerformersText(filters, resultsContext, totalPerformers, translationService.translate)) !== null && _b !== void 0 ? _b : undefined, xmentService: xmentService, hideBackToOnlineLink: hideBackToOnlineLink, setCategoryGroupIndex: setCategoryGroupIndex, setCurrentCategory: setCurrentCategory, categoryGroups: categoryGroups, categoryGroupIndex: categoryGroupIndex, setGenderPreference: setGenderPreference, emitGenderTabEvent: emitGenderTabEvent, pushRoute: pushRoute, genderFilter: genderFilter, ageVerificationRules: ageVerificationRules, blurCategoryLabel: blurMessage }));
            } }));
    };
    SearchResultsSectionHeaderContainer = __decorate([
        (0, Ioc_1.connectContextsToProps)({
            xmentService: Contexts_1.IXmentServiceContext,
            user: Contexts_1.IUserContext,
            // @ts-ignore -- Fix typing for contexts with undefined
            eventPublisher: Contexts_1.IEventPublisherContext,
            router: Contexts_1.IRouterContext,
        })
    ], SearchResultsSectionHeaderContainer);
    return SearchResultsSectionHeaderContainer;
}(React.Component));
exports.SearchResultsSectionHeaderContainer = SearchResultsSectionHeaderContainer;
//# sourceMappingURL=SearchResultsSectionHeaderContainer.js.map